import { render } from "./NextPanel.vue?vue&type=template&id=7295677e"
import script from "./NextPanel.vue?vue&type=script&lang=js"
export * from "./NextPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/investment-forecaster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__